module.exports = __webpack_public_path__ + "static/media/galerija_2021 (4)-min.b52fee04.jpg";